import { SummaryReactionLatestBy } from 'src/client/publication/types'

export type UsePostSummaryReactionsParams = {
  postId: number
  canFetch?: boolean
}

export type SummaryReactionsType = {
  [code: string]: { latestBy: SummaryReactionLatestBy[]; remaining?: number }
}

export enum SummaryReactionsFetchStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  Error = 'error'
}

export type PendingAction = {
  type: 'add' | 'remove'
  reactionCode: string
} | null
